import { SectionHeaderSkeleton, ListPanelBodySkeleton } from '../app-layout-skeleton'

export function ListPanePending() {
  return (
    <>
      <SectionHeaderSkeleton />
      <ListPanelBodySkeleton />
    </>
  )
}
